import PropTypes from "prop-types";
import React, { Component } from "react";
import Globalize from "globalize";
import Catalogs from "./catalogs";
import Catalog from "models/catalog";
import Button from "components/form/flat-button";
import Entry from "models/catalog/entry";
import fetch from "lib/fetch";
import Dialog, { Prompt } from "components/dialog";
import TextField from "components/form/text-field";
import { Form } from "formsy-react";
import CancelIcon from "material-ui/svg-icons/navigation/cancel";
import theme from "styles/theme";
import debounce from "lodash/debounce";
import { Link } from "react-router";
import { FormatMessage } from "react-globalize";
import { VIEWPORT_MOBILE } from "constants/media";
import MenuItem from "material-ui/MenuItem";
import IconMenu from "material-ui/IconMenu";
import IconButton from "material-ui/IconButton";
import MoreIcon from "material-ui/svg-icons/navigation/more-vert";
import moment from "moment";
import CatalogDeliveryWindows from "components/catalog/header/catalog-delivery-windows";
import { DATATEST } from "constants/integration";
import { Restriction, setValues, setOption } from "components/catalog/header/restrictions";
import _ from "lodash";
import fp from "lodash/fp";
import { getCatalogSummaryMessage } from "helpers/catalog-entries";
import { MODE } from "constants/restrictions";
import { gtm } from "helpers/gtm";

const { WHITELIST } = MODE;

const styles = {
    container: {},
    dialog: {
        // move dialog to top instead of center of page
        paddingTop: "0px",
    },
    dialogContent: {
        maxWidth: "720px",
    },
    button: {
        position: "absolute",
        top: "18px",
        right: "54px",
    },
    title: {
        marginBottom: "0px",
    },
    input: {
        marginTop: "8px",
        width: "100%",
    },
    cancelSearch: {
        position: "absolute",
        top: "92px",
        right: "31px",
        cursor: "pointer",
    },
    catalogDeliveryWindows: {
        marginTop: "24px",
        marginBottom: "24px",
    },
};

class CatalogAddItem extends Component {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    static propTypes = {
        activeList: PropTypes.object,
        bulkItems: PropTypes.object,
        catalogType: PropTypes.oneOf(["custom-list", "linesheet"]),
        currentCatalog: PropTypes.object,
        filters: PropTypes.object,
        item: PropTypes.object,
        type: PropTypes.oneOf(["item", "catalog"]),
        entities: PropTypes.object,
        notes: PropTypes.string,
        onActiveListAdd: PropTypes.func.isRequired,
        onActiveListFetchEntries: PropTypes.func,
        onActiveListRemove: PropTypes.func,
        onAdd: PropTypes.func,
        onRequestClose: PropTypes.func.isRequired,
        onSetActiveList: PropTypes.func,
        open: PropTypes.bool.isRequired,
        scope: PropTypes.object,
        sortBy: PropTypes.string,
        positionToAdd: PropTypes.string,
        sortOrder: PropTypes.string,
        onSnackbarAdd: PropTypes.func.isRequired,
        viewport: PropTypes.string,
        searchTerm: PropTypes.string,
        deliveryWindows: PropTypes.array.isRequired,
        fetchingWindows: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        catalogType: "custom-list",
    };

    constructor(props) {
        super(props);

        const options = getDefaultOptions(props.scope.brand);
        const restrictions = getRestrictions(props.scope.brand);

        this.state = {
            catalogNamePromptOpen: false,
            search: "",
            options,
            groups: setValues(options.groups, restrictions.values, "customer_group"),
            warehouses: setValues(options.warehouses, options.warehouses, "warehouse"),
            ...this.handleFormatTemporaryCatalog(props),
        };

        this.handleCreateNewList = this.handleCreateNewList.bind(this);
        this.handlePromptCancel = this.handlePromptCancel.bind(this);
        this.handlePromptForCatalogName = this.handlePromptForCatalogName.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearch = debounce(this.handleSearch.bind(this), 750);
        this.handleCancelSearch = this.handleCancelSearch.bind(this);
        this.handleDeliveryWindowChange = this.handleDeliveryWindowChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { scope = {}, currentCatalog } = this.props;
        const options = getDefaultOptions(scope.brand);
        const restrictions = getRestrictions(scope.brand);

        const useCatalogWarehouses = !!scope.brand.getPreference("set_warehouse_for_linesheets");
        const currentCatalogRestrictions = _.keyBy(currentCatalog?.restrictions, "value");
        const selectedWarehouses = useCatalogWarehouses
            ? _.filter(options.warehouses, (w) => currentCatalogRestrictions[w.value])
            : options.warehouses;

        this.setState({
            groups: setValues(options.groups, restrictions.values, "customer_group"),
            warehouses: selectedWarehouses,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            this.props.bulkItems &&
            nextProps.bulkItems &&
            this.props.bulkItems.allSelected !== nextProps.bulkItems.allSelected
        ) {
            this.setState({
                ...this.handleFormatTemporaryCatalog(nextProps),
            });
        }
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    checkIfLinesheetsAreCatalogs = () => {
        const { scope } = this.props;
        return scope && scope.brand && scope.brand.hasPreference("linesheets_are_catalogs");
    };

    handleAddItemToNewList(catalog) {
        const { me } = this.context;
        const {
            item,
            bulkItems,
            filters,
            searchTerm,
            onRequestClose,
            currentCatalog,
            notes,
            activeList,
            positionToAdd,
            onActiveListAdd,
            onActiveListRemove,
            onActiveListFetchEntries,
            type,
            entities,
            onSnackbarAdd,
            sortBy,
            sortOrder,
            scope,
        } = this.props;

        const updateActiveList = onActiveListAdd && catalog?.type !== "linesheet";
        const catalogType = catalog?.type === "linesheet" ? "linesheet" : "list";
        const { items, value } = gtm.formatItemsWithBulk({
            items: { single: item, bulk: bulkItems },
            props: { entities, scope },
            list: { affiliation: catalogType, item_list_id: catalog?.id, item_list_name: catalog?.title },
        });
        gtm.emit(
            gtm.events.addToWishlist({
                currency: me._activeCurrency,
                items,
                value,
                send_to: gtm.groups.Brand,
            })
        );
        if (item) {
            const entry = new Entry();
            if (updateActiveList) {
                onActiveListAdd(item._id);
            }
            entry.save(
                {
                    item_id: item._id,
                    type: "item",
                    catalogId: catalog.id,
                    notes: notes,
                    company: scope.viewAs && scope.viewAs._id,
                },
                {
                    success: () => {
                        me.trackAction("Add item to catalog", {
                            selectAll: false,
                            createNew: true,
                            bulk: false,
                            type: catalogType,
                        });
                        me.trackAction("Create new catalog", {
                            type: catalogType,
                            withItems: true,
                        });
                    },
                    error: (model, { statusCode }) => {
                        if (statusCode !== 409) {
                            onActiveListRemove(item._id);
                        }
                    },
                }
            );
        } else if (bulkItems && bulkItems.size) {
            // assume bulk action
            let data;
            const itemFilters = bulkItems.toFilters((id) => (type === "item" ? id : entities.entries[id].item_id));
            if (bulkItems.allSelected) {
                data = filters ? filters.toJS() : {};
                data.__sort = sortBy;
                data.__sort_order = sortOrder;
                if (searchTerm) {
                    data.__search = searchTerm;
                }

                if (currentCatalog) {
                    data.__catalog_id = currentCatalog.id;
                }

                // Filter disabled products
                data.__archived = false;
                const active = data.__active || "active";
                delete data.__active;
                switch (active) {
                    case "all":
                        data.__view_disabled = true;
                        break;
                    case "inactive":
                        data.__view_disabled = true;
                        data.__active = false;
                        break;
                    case "active":
                    default:
                        data.__active = true;
                        data.__view_disabled = false;
                }
                Object.assign(data, itemFilters);
            } else {
                data = {
                    __sort: sortBy,
                    __sort_order: sortOrder,
                    __catalog_id: currentCatalog ? currentCatalog.id : undefined,
                    ...itemFilters,
                };
            }

            if (scope.viewAs) {
                data.__company = [scope.viewAs._id];
            }

            if (positionToAdd) {
                data.__position = positionToAdd;
            }
            const useWarehouseValidation = scope?.brand?.hasPreference("set_warehouse_for_linesheets");
            const route = useWarehouseValidation
                ? `/api/v3.1/catalog/${catalog.id}/entries/bulk/summarized`
                : `/api/v3.1/catalog/${catalog.id}/entries/bulk`;

            fetch(route, { method: "POST", body: JSON.stringify(data) })
                .then((response) => {
                    if (response.status > 300) {
                        if (!bulkItems.allSelected) {
                            onActiveListRemove(data._id);
                        }
                        return response.json().then((data) => {
                            throw new Error(data.message || Globalize.formatMessage("Bad response from server"));
                        });
                    }
                    return response.json().then((data = {}) => {
                        const { createdEntries = [] } = data;

                        me.trackAction("Add item to catalog", {
                            selectAll: bulkItems.allSelected,
                            createNew: true,
                            bulk: !item,
                            type: catalog.type === "linesheet" ? "linesheet" : "list",
                        });
                        me.trackAction("Create new catalog", {
                            type: catalog.type === "linesheet" ? "linesheet" : "list",
                            withItems: true,
                        });

                        if (updateActiveList && !bulkItems.allSelected) {
                            onActiveListAdd(_.map(createdEntries, "item_id"));
                        }

                        if (bulkItems.allSelected && activeList.current && catalog.id === activeList.current.id) {
                            onActiveListFetchEntries();
                        }

                        if (useWarehouseValidation) {
                            onSnackbarAdd?.({ message: getCatalogSummaryMessage(catalog, data) });
                            return data.entries;
                        }
                        return data;
                    });
                })
                .catch((e) => {
                    onSnackbarAdd({ message: e.message });
                });
        }

        onRequestClose();
    }

    handleFormatTemporaryCatalog(props = this.props) {
        const { scope, currentCatalog, item, bulkItems, entities } = props;
        const requireCatalogDates = scope.brand.getPreference("require_catalog_dates");
        const minimumDeliveryWindow = scope.brand.getPreference("minimum_delivery_window");

        const temporaryCatalog = {};
        if (requireCatalogDates) {
            const defaultDeliveryWindow = scope.brand.preferences.get("default_delivery_window");
            let itemForDates = null;
            temporaryCatalog.delivery_window_start = moment.utc();
            temporaryCatalog.delivery_window_end = moment
                .utc(temporaryCatalog.delivery_window_start)
                .add(defaultDeliveryWindow, "days");
            if (currentCatalog) {
                temporaryCatalog.delivery_window_start = currentCatalog.delivery_window_start
                    ? moment.utc(currentCatalog.delivery_window_start)
                    : moment.utc();
                temporaryCatalog.delivery_window_end = currentCatalog.delivery_window_end
                    ? moment.utc(currentCatalog.delivery_window_end)
                    : moment.utc().add(defaultDeliveryWindow, "days");
                temporaryCatalog.prebook = currentCatalog.prebook;
            } else if (item) {
                itemForDates = item;
            } else {
                if (bulkItems && bulkItems.size) {
                    if (bulkItems.allSelected) {
                        temporaryCatalog.delivery_window_start = moment.utc();
                        temporaryCatalog.delivery_window_end = moment
                            .utc(temporaryCatalog.delivery_window_start)
                            .add(defaultDeliveryWindow, "days");
                    } else {
                        const firstBulkItemId = bulkItems.first();
                        itemForDates = entities && entities.items[firstBulkItemId];
                    }
                }
            }
            if (itemForDates) {
                temporaryCatalog.delivery_window_start = itemForDates.__available_from.isBefore(moment.utc())
                    ? moment.utc()
                    : itemForDates.__available_from;
                temporaryCatalog.delivery_window_end = moment
                    .utc(temporaryCatalog.delivery_window_start)
                    .add(defaultDeliveryWindow, "days");
            }
        }

        return {
            temporaryCatalog,
            requireCatalogDates,
            minimumDeliveryWindow,
        };
    }

    handleCreateNewList(title) {
        const { catalogType, onSetActiveList, onSnackbarAdd } = this.props;
        const { temporaryCatalog, groups, warehouses } = this.state;
        this.setState({ catalogNamePromptOpen: false });

        if (!title) {
            title =
                catalogType === "custom-list"
                    ? Globalize.formatMessage("Untitled List")
                    : Globalize.formatMessage("Untitled Linesheet", {
                          Linesheet: this.checkIfLinesheetsAreCatalogs()
                              ? Globalize.formatMessage("Catalog")
                              : Globalize.formatMessage("Linesheet"),
                      });
        }

        const catalog = new Catalog({
            title,
            active: catalogType === "custom-list",
            type: catalogType,
            restrictions: catalogType === "linesheet" ? [...groups, ...warehouses] : warehouses,
            ...temporaryCatalog,
        });

        catalog.save(null, {
            success: () => {
                if (onSetActiveList && catalogType === "custom-list") {
                    onSetActiveList(catalog, { fetch: false });
                }
                this.handleAddItemToNewList(catalog);
                onSnackbarAdd({
                    message: (
                        <span>
                            <FormatMessage
                                path="Catalog created"
                                variables={{ catalog: catalog.title }}
                                elements={{ link: <Link to={catalog._link} /> }}
                            />
                        </span>
                    ),
                });
            },
            error: (rawResponse, status, response) => {
                const defaultError =
                    catalogType === "custom-list"
                        ? Globalize.formatMessage("Error creating list")
                        : Globalize.formatMessage("Error creating linesheet", {
                              linesheet: this.checkIfLinesheetsAreCatalogs()
                                  ? Globalize.formatMessage("catalog")
                                  : Globalize.formatMessage("linesheet"),
                          });
                onSnackbarAdd({ message: response.message || defaultError });
            },
        });
    }

    handlePromptForCatalogName() {
        this.setState({ catalogNamePromptOpen: true });
    }

    handlePromptCancel() {
        this.setState({ catalogNamePromptOpen: false });
    }

    handleSearch(listSearch) {
        this.setState({ listSearch });
    }

    handleSearchChange(event, listSearch) {
        this.setState({ search: listSearch });
        this.handleSearch(listSearch);
    }

    handleCancelSearch() {
        this.setState({ search: "" });
        this.handleSearch("");
    }

    handleDeliveryWindowChange(windowChanges) {
        const { minimumDeliveryWindow } = this.state;
        let requiredValidation = false;
        if (windowChanges.delivery_window_start && !windowChanges.delivery_window_end) {
            delete windowChanges.delivery_window_end;
            requiredValidation = true;
        }

        const temporaryCatalog = {
            ...this.state.temporaryCatalog,
            ...windowChanges,
        };

        if (temporaryCatalog.delivery_window_start) {
            temporaryCatalog.delivery_window_start = moment.isMoment(temporaryCatalog.delivery_window_start)
                ? temporaryCatalog.delivery_window_start
                : moment.utc(temporaryCatalog.delivery_window_start);
        }

        if (temporaryCatalog.delivery_window_end) {
            temporaryCatalog.delivery_window_end = moment.isMoment(temporaryCatalog.delivery_window_end)
                ? temporaryCatalog.delivery_window_end
                : moment.utc(temporaryCatalog.delivery_window_end);
        }

        if (requiredValidation) {
            if (
                temporaryCatalog.delivery_window_start
                    .clone()
                    .add(minimumDeliveryWindow, "days")
                    .isAfter(temporaryCatalog.delivery_window_end)
            ) {
                temporaryCatalog.delivery_window_end = temporaryCatalog.delivery_window_start
                    .clone()
                    .add(minimumDeliveryWindow, "days");
            }
        }

        this.setState({ temporaryCatalog });
    }

    render() {
        const {
            open,
            onRequestClose,
            item,
            bulkItems,
            filters,
            entities,
            type,
            searchTerm,
            catalogType,
            currentCatalog,
            notes,
            scope,
            sortBy,
            onSnackbarAdd,
            sortOrder,
            viewport,
            positionToAdd,
            fetchingWindows,
            deliveryWindows,
        } = this.props;

        const useCatalogWarehouses = !!scope.brand.getPreference("set_warehouse_for_linesheets");

        const {
            catalogNamePromptOpen,
            search,
            listSearch,
            requireCatalogDates,
            temporaryCatalog,
            groups,
            warehouses,
            options,
        } = this.state;

        const isMobile = viewport === VIEWPORT_MOBILE;

        let searchForm = null;

        if (catalogType === "custom-list") {
            searchForm = (
                <Form>
                    <TextField
                        hintText={Globalize.formatMessage("Search Lists")}
                        large={false}
                        style={styles.input}
                        onChange={this.handleSearchChange}
                        value={search}
                        name="list-search"
                        allowWhitespace={true}
                        autoFocus
                    />
                    {search && (
                        <CancelIcon
                            color={theme.palette.grey}
                            style={styles.cancelSearch}
                            onClick={this.handleCancelSearch}
                        />
                    )}
                </Form>
            );
        }

        let dialogTitle, buttonLabel;

        if (!open) {
            return null;
        }

        if (item || bulkItems) {
            if (catalogType === "custom-list") {
                dialogTitle = Globalize.formatMessage("Add to List");
                buttonLabel = Globalize.formatMessage("Create New List");
            } else {
                dialogTitle = Globalize.formatMessage("Add To Linesheet", {
                    Linesheet: this.checkIfLinesheetsAreCatalogs()
                        ? Globalize.formatMessage("Catalog")
                        : Globalize.formatMessage("Linesheet"),
                });
                buttonLabel = Globalize.formatMessage("Create New Linesheet", {
                    Linesheet: this.checkIfLinesheetsAreCatalogs()
                        ? Globalize.formatMessage("Catalog")
                        : Globalize.formatMessage("Linesheet"),
                });
            }
        } else {
            dialogTitle = Globalize.formatMessage("Select Active List");
            buttonLabel = Globalize.formatMessage("Create New List");
        }

        return (
            <div>
                <Dialog
                    title={dialogTitle}
                    modal={false}
                    repositionOnUpdate={false}
                    autoScrollBodyContent={false}
                    open={open}
                    onRequestClose={onRequestClose}
                    style={styles.dialog}
                    contentStyle={styles.dialogContent}
                    titleStyle={styles.title}
                >
                    {searchForm}
                    <div style={styles.container}>
                        <Catalogs
                            currentCatalog={currentCatalog}
                            bulkItems={bulkItems}
                            filters={filters}
                            item={item}
                            entities={entities}
                            type={type}
                            listSearch={listSearch}
                            notes={notes}
                            onRequestClose={onRequestClose}
                            searchTerm={searchTerm}
                            sortBy={sortBy}
                            scope={scope}
                            sortOrder={sortOrder}
                            positionToAdd={positionToAdd}
                            catalogType={catalogType}
                            onSnackbarAdd={onSnackbarAdd}
                        />
                        {!isMobile && (
                            <Button
                                style={styles.button}
                                onClick={this.handlePromptForCatalogName}
                                label={buttonLabel}
                                data-test={DATATEST.GALLERY.BULK_CREATE_NEW_CATALOG}
                            />
                        )}
                        {isMobile && (
                            <IconMenu
                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                targetOrigin={{ vertical: "top", horizontal: "right" }}
                                iconStyle={{ fill: "#333" }}
                                iconButtonElement={
                                    <IconButton>
                                        <MoreIcon />
                                    </IconButton>
                                }
                                style={styles.button}
                            >
                                <MenuItem
                                    primaryText={buttonLabel}
                                    data-test={DATATEST.GALLERY.BULK_CREATE_NEW_CATALOG}
                                    onClick={this.handlePromptForCatalogName}
                                />
                            </IconMenu>
                        )}
                    </div>
                    <Prompt
                        placeholder={Globalize.formatMessage("Please enter name")}
                        title={
                            catalogType === "custom-list"
                                ? Globalize.formatMessage("New List")
                                : Globalize.formatMessage("New Linesheet", {
                                      Linesheet: this.checkIfLinesheetsAreCatalogs()
                                          ? Globalize.formatMessage("Catalog")
                                          : Globalize.formatMessage("Linesheet"),
                                  })
                        }
                        open={catalogNamePromptOpen}
                        onSubmit={this.handleCreateNewList}
                        onCancel={this.handlePromptCancel}
                        textFieldLabel={
                            catalogType === "custom-list"
                                ? Globalize.formatMessage("List Name")
                                : Globalize.formatMessage("Linesheet Name", {
                                      Linesheet: this.checkIfLinesheetsAreCatalogs()
                                          ? Globalize.formatMessage("Catalog")
                                          : Globalize.formatMessage("Linesheet"),
                                  })
                        }
                    >
                        <React.Fragment>
                            <div style={styles.catalogDeliveryWindows}>
                                <CatalogDeliveryWindows
                                    catalog={temporaryCatalog}
                                    editable={true}
                                    scope={scope}
                                    deliveryWindows={deliveryWindows}
                                    onDeliveryWindowChange={this.handleDeliveryWindowChange}
                                    deliveryWindowStart={temporaryCatalog.delivery_window_start}
                                    deliveryWindowEnd={temporaryCatalog.delivery_window_end}
                                    prebook={!!temporaryCatalog.prebook}
                                    fetchingWindows={fetchingWindows}
                                    requireCatalogDates={requireCatalogDates}
                                />
                            </div>
                            {scope.brand.modules.base.customer_groups.length > 0 && catalogType === "linesheet" && (
                                <Restriction
                                    dataTest={DATATEST.CATALOG.ALLOWED_CUSTOMER_GROUPS_SELECTOR}
                                    label={Globalize.formatMessage("Allowed Customer Groups")}
                                    placeholder={Globalize.formatMessage("No customer groups")}
                                    onChange={this.handleChangeRestrictions("groups")}
                                    options={options.groups}
                                    values={groups}
                                />
                            )}
                            {useCatalogWarehouses && (
                                <Restriction
                                    errorText={Globalize.formatMessage("Field Required")}
                                    dataTest={DATATEST.CATALOG.VISIBLE_WAREHOUSES_SELECTOR}
                                    label={Globalize.formatMessage("Warehouse")}
                                    placeholder={Globalize.formatMessage("Select warehouse")}
                                    onChange={this.handleChangeRestrictions("warehouses")}
                                    options={options.warehouses}
                                    values={warehouses}
                                    mode={MODE.WHITELIST}
                                />
                            )}
                        </React.Fragment>
                    </Prompt>
                </Dialog>
            </div>
        );
    }

    handleChangeRestrictions = (field) => (values) => {
        this.setState({ [field]: values });
    };
}

const getDefaultOptions = (brand = {}) => {
    return {
        groups: _.map(brand.modules?.base.customer_groups, (group) =>
            setOption("customer_group", group._id, group.name)
        ),
        warehouses: fp.compose(
            fp.map(({ name, _id }) => setOption("warehouse", _id, name, WHITELIST)),
            fp.orderBy(["created_on"], ["desc"])
        )(brand.settings?.warehouses),
    };
};

const getRestrictions = (brand = {}) => {
    return {
        values: _.map(
            brand?.modules?.base?.customer_groups?.filter((group) => group.exclude === true),
            (group) => setOption("customer_group", group._id, group.name)
        ),
    };
};
export default CatalogAddItem;
